import { createSlice } from '@reduxjs/toolkit'

export const playerStateSlice = createSlice({
  name: 'playerState',
  initialState: {
      id: 0,
      name: "",
      host: false,
      faker: false,
      colour: "#0000FF",
      voted: false,
      myVote: "",
  },
  reducers: {
    initPlayerState: (state, action) => {
      const newPlayer = action.payload;
      return newPlayer
    },
    setPlayerId: (state, action) => {
      state.id = action.payload
    },
    setPlayerName: (state, action) => {
      state.name = action.payload
    },
    setHost: (state, action) => {
      state.host = action.payload
    },
    setFaker: (state, action) => {
      state.faker = action.payload
    },
    setColor: (state, action) => {
      state.colour = action.payload
    },
    setVoted: (state) => {
      state.voted = !state.voted
    },
    setPlayerColour: (state, action) => {
      state.colour = action.payload
    },
    setVote: (state, action) => {
      state.myVote = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { initPlayerState, setPlayerId, setPlayerName, setHost, setFaker, setColor, setVoted, setPlayerColour, setVote } = playerStateSlice.actions

export default playerStateSlice.reducer